<template>
  <svg
    aria-hidden="true"
    viewBox="0 0 67 64"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
  >
    <g>
      <path
        d="M15.088 52H1.019V17h64.962v35H51.567"
        stroke-width="2"
      />
      <path
        d="M51.995 44.046v19.047h-37V44.046M12 16.842V1h43v15.958"
        stroke-width="2"
      />
      <path
        d="M20 51.033h27M20 56.973h27M8.995 44.974h49M46 27h13"
        stroke-width="2"
      />
    </g>
  </svg>
</template>
